import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface PasswordChangeSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  password: string;
  onPasswordChange: (value: string) => void;
  onSave: () => void;
  loading: boolean;
}

export const PasswordChangeSheet: React.FC<PasswordChangeSheetProps> = ({
  open,
  onOpenChange,
  password,
  onPasswordChange,
  onSave,
  loading,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClose = () => {
    onOpenChange(false);
    onPasswordChange("");
    setShowPassword(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent>
        <SheetHeader>
          <SheetTitle>Change Password</SheetTitle>
          <SheetDescription>Enter your new password below</SheetDescription>
        </SheetHeader>

        <div className="mt-6">
          <div className="relative">
            <Input
              type={showPassword ? "text" : "password"}
              placeholder="Enter new password"
              autoComplete="new-password"
              disabled={loading}
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              required
            />
            <Button
              size="sm"
              variant="ghost"
              className="absolute right-0 top-0 h-full px-3"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? "Hide" : "Show"}
            </Button>
          </div>

          <div className="flex justify-end gap-2 mt-6">
            <Button disabled={loading} onClick={onSave}>
              Save Changes
            </Button>
            <Button variant="outline" onClick={handleClose}>
              Cancel
            </Button>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
};
